export const SCORE_KEY = 'ladder-original-high-scores-v1';
const NAME_KEY = 'ladder-high-score-player';
export const SCORE_LIMIT = 10;
export const playerName = value => (typeof value === 'string' ? value.replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, 16) : '') || 'Player';

function valid(entry) {
    return entry && typeof entry.id === 'string' && entry.id.length <= 100 && entry.id.length > 0 &&
        typeof entry.name === 'string' && entry.name === playerName(entry.name) &&
        Number.isSafeInteger(entry.score) && entry.score > 0 &&
        Number.isSafeInteger(entry.level) && entry.level > 0 &&
        Number.isInteger(entry.speed) && entry.speed >= 1 && entry.speed <= 5 &&
        typeof entry.date === 'string' && Number.isFinite(Date.parse(entry.date));
}

function read(storage) {
    const raw = storage.getItem(SCORE_KEY);
    if (raw === null) return [];
    if (raw.length > 32000) throw new Error('Invalid high-score data');
    const data = JSON.parse(raw);
    if (data.version !== 1 || !Array.isArray(data.entries) || data.entries.length > SCORE_LIMIT || !data.entries.every(valid)) throw new Error('Invalid high-score data');
    return data.entries;
}

function ranked(entries) {
    return [...new Map(entries.map(entry => [entry.id, entry])).values()]
        .sort((a, b) => b.score - a.score || Date.parse(a.date) - Date.parse(b.date) || a.id.localeCompare(b.id))
        .slice(0, SCORE_LIMIT);
}

export class HighScoreStore {
    constructor(storage = () => localStorage) {
        this.storage = storage;
        this.entries = [];
        this.name = 'Player';
        this.warning = '';
        this.reload();
        try { this.name = playerName(this.storage().getItem(NAME_KEY)); } catch { /* Optional name preference. */ }
    }

    reload() {
        try { this.entries = ranked(read(this.storage())); this.warning = ''; }
        catch { this.warning = 'High-score storage could not be read. New scores will remain in this session unless storage becomes available.'; }
    }

    setName(value) {
        this.name = playerName(value);
        try { this.storage().setItem(NAME_KEY, this.name); } catch { /* Use this name for the current visit. */ }
    }

    qualifies(entry) {
        if (!valid(entry)) return false;
        let entries = this.entries;
        try { entries = ranked([...read(this.storage()), ...entries]); } catch { /* Use session scores when storage is unavailable. */ }
        return !entries.some(item => item.id === entry.id) && ranked([...entries, entry]).some(item => item.id === entry.id);
    }

    add(entry) {
        if (!valid(entry)) return false;
        let storage, writable = false;
        try {
            storage = this.storage();
            this.entries = ranked([...read(storage), ...this.entries]);
            writable = true;
        } catch { /* Preserve unreadable storage instead of silently overwriting it. */ }
        this.entries = ranked([...this.entries, entry]);
        try {
            if (!writable) throw new Error('Storage unavailable');
            storage.setItem(SCORE_KEY, JSON.stringify({ version: 1, entries: this.entries }));
            this.warning = '';
        } catch { this.warning = 'Scores are available for this session only: browser storage could not be saved.'; }
        return this.entries.some(item => item.id === entry.id);
    }
}

export const HighScores = new HighScoreStore();
